import { render } from "./ActionsOzon.vue?vue&type=template&id=43f358e6"
import script from "./ActionsOzon.vue?vue&type=script&lang=js"
export * from "./ActionsOzon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__